module.exports = __webpack_public_path__ + "img/emitFacebeauty05.e36ae12f.png";